module.exports = __webpack_public_path__ + "static/media/long-26.7294c1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-26.png
// module id = 2150
// module chunks = 0